import { Button } from "@/shared/components";
import { Dialog, DialogBody, DialogContainer, DialogFooter, DialogHeader, DialogTitle } from "@/shared/components/ui/dialog";
import { useNavigate } from "react-router";

interface DossierAfgerondDialogProps {
    isOpen: boolean;
    dossierId: string;
}

export function DossierAfgerondDialog({ isOpen, dossierId }: DossierAfgerondDialogProps) {
    const navigate = useNavigate();

    return (
        <Dialog open={isOpen}>
            <DialogContainer dismissible={false}>
                <DialogHeader>
                    <DialogTitle>Dit dossier is afgerond</DialogTitle>
                </DialogHeader>
                <DialogBody>Dit dossier is afgerond. Wil je het afgeronde dossier blijven bekijken?</DialogBody>
                <DialogFooter>
                    <Button variant="tertiary" onClick={() => navigate("/")} ignoreHideButton>
                        Sluit dit dossier
                    </Button>
                    <Button variant="primary" onClick={() => navigate(`/afgerond/dossier/${dossierId}`)} ignoreHideButton>
                        Blijf in afgeronde dossier
                    </Button>
                </DialogFooter>
            </DialogContainer>
        </Dialog>
    );
}
